import { selectWorkerImplementation } from "./implementation";
export { Pool } from "./pool";
export { spawn } from "./spawn";
export { Thread } from "./thread";
/** Worker implementation. Either web worker or a node.js Worker class. */
export const Worker = selectWorkerImplementation();
